import Vue from "vue";
import VueRouter from "vue-router";
import { getUserGuid, common } from "assets/js/util";

// 重写路由
// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }

/**
 * 处理路由页面切换时，异步组件加载过渡的处理函数
 * @param {Object} AsyncView 需要加载的组件，如 import('@/components/home/Home.vue')
 * @return {Object} 返回一个promise对象
 */
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require("base/page-loading/page-loading.vue").default,
    // 加载失败时使用的组件
    error: require("base/page-loadfail/page-loadfail.vue").default,
    delay: 200,
    timeout: 50000
  });
  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children);
    }
  });
}

const indexPage = () =>
  lazyLoadView(
    import(/* webpackChunkName: "indexPage" */ "components/index/index")
  );
const me = () =>
  lazyLoadView(import(/* webpackChunkName: "me" */ "components/me/me"));
const myOrder = () =>
  lazyLoadView(
    import(/* webpackChunkName: "myOrder" */ "components/me/order/order")
  );
const orderDetail = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "orderDetail" */ "components/me/orderDetail/orderDetail"
    )
  );
const productionSchedule = () =>
  lazyLoadView(import("components/me/productionSchedule/productionSchedule"));
const setUp = () => lazyLoadView(import("components/me/setUp/setUp"));
const payResult = () =>
  lazyLoadView(import("components/me/payResult/payResult"));
const userLogin = () => lazyLoadView(import("components/user/index"));
const loginv1 = () =>
  lazyLoadView(
    import(/* webpackChunkName: "loginIndex" */ "components/user/login/index")
  );
const registerv1 = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "registerIndex" */ "components/user/register/register"
    )
  );
const login = () => lazyLoadView(import("components/user/loginV2/index"));
const register = () =>
  lazyLoadView(import("components/user/registerV2/register"));
const inviteRegister = () =>
  lazyLoadView(import("components/user/inviteRegister/register"));
const binding = () => lazyLoadView(import("components/user/loginV2/binding"));
const backpw = () =>
  lazyLoadView(
    import(/* webpackChunkName: "backpwIndex" */ "components/user/backpw/index")
  );
const protocol = () =>
  lazyLoadView(
    import(/* webpackChunkName: "protocol" */ "components/protocol/protocol")
  );
const idh = () =>
  lazyLoadView(import(/* webpackChunkName: "idh" */ "components/idh/idh"));
const idhNew = () =>
  lazyLoadView(import(/* webpackChunkName: "idh" */ "components/idhNew/index"));
const idhDetail = () =>
  lazyLoadView(
    import(/* webpackChunkName: "idhDetail" */ "components/idhDetail/idhDetail")
  );
const shop = () => lazyLoadView(import("components/shop/shop"));
const shopPingDetail = () =>
  lazyLoadView(import("components/shop/shopPingDetail/shopPingDetail"));
const shopPingCart = () =>
  lazyLoadView(import("components/shop/shopPingCart/shopPingCart"));
const addressIndex = () => lazyLoadView(import("components/address/index"));
const address = () => lazyLoadView(import("components/address/index/address"));
const update = () => lazyLoadView(import("components/address/update/update"));
const compIndex = () => lazyLoadView(import("components/comp/index"));
const comp = () => lazyLoadView(import("components/comp/index/index"));
const search = () => lazyLoadView(import("components/comp/search/search"));
const compDetail = () =>
  lazyLoadView(import("components/comp/detail/comDetail"));
const inquiryOrder = () =>
  lazyLoadView(import("components/comp/inquiryOrder/inquiryOrder"));
const yearEnd = () => lazyLoadView(import("components/yearEnd-activities"));
const testActivity = () =>
  lazyLoadView(import("components/pokerActivity/code/code")); // lazyLoadView(import('components/activity/index'))
const pcbMaking = () => lazyLoadView(import("components/pcbMaking"));
const pcbaMaking = () => lazyLoadView(import("components/pcbaMaking"));
// pcbMaking
// 扑克牌活动
const poker = () =>
  lazyLoadView(
    import(/* webpackChunkName: "poker" */ "components/pokerActivity/poker")
  );
const pokerIndex = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "pokerIndex" */ "components/pokerActivity/index/index"
    )
  );
const pokerShare = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "pokerShare" */ "components/pokerActivity/share/share"
    )
  );
const pokerHelp = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "pokerHelp" */ "components/pokerActivity/help/help"
    )
  );
const luckDraw = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "luckDraw" */ "components/pokerActivity/luckDraw/luck-draw"
    )
  );

const ees = () =>
  lazyLoadView(import(/* webpackChunkName: "ees" */ "components/ees/ees"));
const cad = () =>
  lazyLoadView(import(/* webpackChunkName: "cad" */ "components/cad/cad"));
const aboutUs = () =>
  lazyLoadView(
    import(/* webpackChunkName: "aboutUs" */ "components/aboutUs/aboutUs")
  );
const pcb = () =>
  lazyLoadView(import(/* webpackChunkName: "pcb" */ "components/pcb/index"));
const pcbDetail = () =>
  lazyLoadView(
    import(/* webpackChunkName: "pcbDetail" */ "components/pcb/detail/detail")
  );
const perfectInfo = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "pcbDetail" */ "components/pcb/perfectInfo/perfectInfo"
    )
  );
const pcbResult = () =>
  lazyLoadView(
    import(/* webpackChunkName: "pcbResult" */ "components/pcb/result/result")
  );

// 幕尼黑 抽奖活动
const activity = () =>
  lazyLoadView(
    import(/* webpackChunkName: "activity" */ "components/activity/index")
  );
const mnhindex = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "MoNihei" */ "components/activity/MoNihei/index/index"
    )
  );
const cashPrize = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: 'cashPrize' */ "components/activity/MoNihei/cashPrize/cashPrize"
    )
  );

// 工艺能力
const pcbCraft = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "processCapability" */ "components/processCapability/index"
    )
  );
const pcbCraftSecondary = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "processCapability" */ "components/processCapability/details"
    )
  );
const processDeliver = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "processCapability" */ "components/processCapability/deliver"
    )
  );

// pcbA工艺能力
const pcbACraft = () =>
  lazyLoadView(import(/* webpackChunkName: "PCBA" */ "components/pcbA/index"));
const pcbACraftSecondary = () =>
  lazyLoadView(import(/* webpackChunkName: "PCBA" */ "components/pcbA/detail"));
const pcbADeliver = () =>
  lazyLoadView(
    import(/* webpackChunkName: "PCBA" */ "components/pcbA/deliver")
  );

const cadCraft = () =>
  lazyLoadView(import(/* webpackChunkName: "PCBA" */ "components/cadPage"));

// 行业动态
const kbNews = () =>
  lazyLoadView(import(/* webpackChunkName: "news" */ "components/kbNews"));
const kbNewDetail = () =>
  lazyLoadView(import(/* webpackChunkName: "news" */ "components/kbNewDetail"));

// 行业案例
const industryCase = () =>
  lazyLoadView(
    import(/* webpackChunkName: "news" */ "components/industryCase")
  );

Vue.use(VueRouter);
const Router = new VueRouter({
  linkActiveClass: "active",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (to.name !== "rootResult" && savedPosition) {
      return savedPosition;
    }
    // return { x: 0, y: 0 };
  },
  base: "/",
  // base: process.env.NODE_ENV === 'production' ? '/' : '/wap/',
  routes: [
    // {
    //   path: "/",
    //   redirect: {
    //     name: "rootIndex"
    //   }
    // },
    {
      path: "/",
      component: indexPage,
      name: "rootIndex"
    },
    {
      path: "/login",
      component: userLogin,
      name: "userLogin",
      children: [
        {
          path: "inviteRegister",
          component: inviteRegister,
          name: "rootRegister",
          beforeEnter: (to, from, next) => {
            if (
              !/\b(login|register|backpw|binding|inviteRegister)\b/.test(
                from.path
              )
            ) {
              Router.app.$options.store.dispatch(
                "recordBeforeLoginPage",
                from.path
              );
            }
            next();
          }
        },
        {
          path: "index",
          component: login,
          name: "rootLogin",
          beforeEnter: (to, from, next) => {
            if (!/\b(login|register|backpw|binding)\b/.test(from.path)) {
              Router.app.$options.store.dispatch(
                "recordBeforeLoginPage",
                from.path
              );
            }
            next();
          }
        },
        {
          path: "register",
          component: register,
          name: "rootRegister",
          beforeEnter: (to, from, next) => {
            if (!/\b(login|register|backpw|binding)\b/.test(from.path)) {
              Router.app.$options.store.dispatch(
                "recordBeforeLoginPage",
                from.path
              );
            }
            next();
          }
        }
      ]
    },
    {
      path: "/register",
      component: register,
      name: "rootRegister",
      beforeEnter: (to, from, next) => {
        if (!/\b(login|register|backpw|binding)\b/.test(from.path)) {
          Router.app.$options.store.dispatch(
            "recordBeforeLoginPage",
            from.path
          );
        }
        next();
      }
    },
    //  {
    //       path: '/inviteRegister',
    //       component: inviteRegister,
    //       name: 'rootRegister',
    //       beforeEnter: (to, from, next) => {
    //         if (!/\b(login|register|backpw|binding|inviteRegister)\b/.test(from.path)) {
    //           Router.app.$options.store.dispatch('recordBeforeLoginPage', from.path);
    //         }
    //         next();
    //       }
    //  },
    //     {
    //       path: '/login',
    //       component: login,
    //       name: 'rootLogin',
    //       beforeEnter: (to, from, next) => {
    //         if (!/\b(login|register|backpw|binding)\b/.test(from.path)) {
    //           Router.app.$options.store.dispatch('recordBeforeLoginPage', from.path);
    //         }
    //         next();
    //       }
    //     },
    {
      path: "/binding",
      component: binding,
      name: "rootBinding",
      meta: {
        isInnerPage: true,
        title: "账号绑定"
      },
      beforeEnter: (to, from, next) => {
        if (!/\b(login|register|backpw|binding)\b/.test(from.path)) {
          Router.app.$options.store.dispatch(
            "recordBeforeLoginPage",
            from.path
          );
        }
        next();
      }
    },
    {
      path: "/backpw",
      component: backpw,
      name: "rootBackpw",
      beforeEnter: (to, from, next) => {
        if (!/\b(login|register|backpw|binding)\b/.test(from.path)) {
          Router.app.$options.store.dispatch(
            "recordBeforeLoginPage",
            from.path
          );
        }
        next();
      }
    },
    {
      path: "/protocol",
      component: protocol,
      name: "rootProtocol"
    },
    {
      path: "/me",
      component: me,
      name: "rootMe",
      children: [
        {
          path: "order",
          name: "MeOrder",
          component: myOrder,
          meta: {
            isInnerPage: true
          }
        },
        {
          path: "orderDetail",
          name: "orderDetail",
          component: orderDetail,
          meta: {
            isInnerPage: true,
            title: "订单详情"
          }
        },
        {
          path: "productionSchedule",
          name: "productionSchedule",
          component: productionSchedule,
          meta: {
            isInnerPage: true,
            title: "生产进度"
          }
        },
        {
          path: "setUp",
          name: "setUp",
          component: setUp,
          meta: {
            isInnerPage: true,
            title: "设置"
          }
        },
        {
          path: "payResult",
          name: "sepayResulttUp",
          component: payResult,
          meta: {
            isInnerPage: true,
            title: "支付"
          }
        }
      ]
    },
    {
      path: "/project",
      component: idh,
      name: "idh",
      meta: {
        title: "IDH集成产品设计丨造物云"
      }
    },
    {
      path: "/projectNew",
      component: idhNew,
      name: "idhNew",
      meta: {
        title: "IDH集成产品设计丨造物云"
      }
    },
    {
      path: "/idhDetail",
      component: idhDetail,
      name: "idhDetail"
    },
    {
      path: "/shop",
      component: shop,
      name: "shop",
      children: [
        {
          path: "shopPingDetail",
          name: "shopPingDetail",
          component: shopPingDetail,
          meta: {
            isInnerPage: true,
            title: "购物车的订单详情"
          }
        },
        {
          path: "shopPingCart",
          name: "shopPingCart",
          component: shopPingCart,
          meta: {
            isInnerPage: true,
            title: "购物车"
          }
        }
      ]
    },
    {
      path: "/address",
      component: addressIndex,
      name: "index",
      children: [
        {
          path: "index",
          component: address,
          name: "address",
          meta: {
            isInnerPage: true,
            title: "邮寄地址"
          }
        },
        {
          path: "update",
          component: update,
          name: "update",
          meta: {
            isInnerPage: true,
            title: "修改添加地址"
          }
        }
      ]
    },
    {
      path: "/comp",
      component: compIndex,
      name: "compIndex",
      children: [
        // {
        //   path: "index",
        //   component: comp,
        //   name: "comp",
        //   meta: {
        //     title: "元器件首页"
        //   }
        // },
        {
          path: "search",
          component: search,
          name: "search",
          meta: {
            title: "搜索页"
          }
        },
        {
          path: "compDetail",
          component: compDetail,
          name: "compDetail",
          meta: {
            title: "信息详情"
          }
        },
        {
          path: "inquiryOrder",
          component: inquiryOrder,
          name: "inquiryOrder",
          meta: {
            title: "询价订单"
          }
        }
      ]
    },
    {
      path: "/poker",
      component: poker,
      name: "poker",
      children: [
        {
          path: "/",
          component: pokerIndex,
          name: "pokerIndex",
          meta: {
            title: "活动首页"
          }
        },
        {
          path: "share",
          component: pokerShare,
          name: "pokerShare",
          meta: {
            title: "活动分享"
          }
        },
        {
          path: "help",
          component: pokerHelp,
          name: "pokerHelp",
          meta: {
            title: "好友助力"
          }
        },
        {
          path: "luckDraw",
          component: luckDraw,
          name: "luckDraw",
          meta: {
            title: "兑奖"
          }
        }
      ]
    },
    {
      path: "/newActivity",
      component: yearEnd,
      name: "yearEnd",
      meta: {
        title: "年终活动"
      }
    },
    {
      path: "/testActivity",
      component: testActivity,
      name: "testActivity",
      meta: {
        title: "testActivity"
      }
    },

    {
      path: "/server",
      component: ees,
      name: "ees",
      meta: {
        title: "EES电子工程检测服务丨造物云"
      }
    },
    {
      path: "/cad",
      component: cad,
      name: "cad",
      meta: {
        title: "高速PCB设计服务丨造物云"
      }
    },
    {
      path: "/aboutUs",
      component: aboutUs,
      name: "aboutUs",
      meta: {
        title: "关于我们丨造物云"
      }
    },
    {
      path: "/index/PCB",
      component: pcb,
      name: "pcb",
      meta: {
        title: "PCB、BOM、PCBA在线下单 |  造物云"
      }
    },
    {
      path: "/index/PCBA",
      component: pcb,
      name: "pcb",
      meta: {
        title: "PCB、BOM、PCBA在线下单 |  造物云"
      }
    },
    {
      path: "/pcbDetail",
      component: pcbDetail,
      name: "pcbDetail"
    },
    {
      path: "/perfectInfo",
      component: perfectInfo,
      name: "perfectInfo"
    },
    {
      path: "/pcbResult",
      component: pcbResult,
      name: "pcbResult",
      meta: {
        title: "提交审核"
      }
    },
    {
      path: "/activity",
      component: activity,
      name: "首页",
      children: [
        {
          path: "mnhindex",
          component: mnhindex,
          name: "mnhindex",
          meta: {
            title: "活动首页"
          }
        },
        {
          path: "cashPrize",
          component: cashPrize,
          name: "cashPrize",
          meta: {
            title: "活动兑奖页面"
          }
        }
      ]
    },
    {
      path: "/pcbCraft",
      component: pcbCraft,
      name: "pcbCraft",
      meta: {
        title: "PCB生产与制造能力 |  造物云"
      }
    },
    {
      path: "/pcbCraftSecondary",
      component: pcbCraftSecondary,
      name: "pcbCraftSecondary",
      meta: {
        title: "HDI PCB |  造物云"
      }
    },
    {
      path: "/processDeliver",
      component: processDeliver,
      name: "processDeliver",
      meta: {
        title: "工艺&交付 | 造物云"
      }
    },
    {
      path: "/pcbACraft",
      component: pcbACraft,
      name: "pcbACraft",
      meta: {
        title: "PCBA生产与制造能力 |  造物云"
      }
    },
    {
      path: "/pcbACraftSecondary",
      component: pcbACraftSecondary,
      name: "pcbACraftSecondary",
      meta: {
        title: "电梯安全检测PCBA |  造物云"
      }
    },
    {
      path: "/pcbMaking",
      component: pcbMaking,
      name: "pcbMaking",
      meta: {
        title: "PCB加工_PCB厂家_电路板生产_线路板制造厂_造物云"
      }
    },
    {
      path: "/pcbAMaking",
      component: pcbaMaking,
      name: "pcbAMaking",
      meta: {
        title: "PCBA_PCBA装联_SMT贴片_电路板装联厂_造物云"
      }
    },
    {
      path: "/pcbADeliver",
      component: pcbADeliver,
      name: "pcbADeliver",
      meta: {
        title: "PCBA生产与制造能力 |  造物云"
      }
    },
    {
      path: "/kbNews",
      component: kbNews,
      name: "kbNews",
      meta: {
        title: "造物动态 | 造物云"
      }
    },
    {
      path: "/kbNewDetail",
      component: kbNewDetail,
      name: "kbNewDetail",
      meta: {
        title: "造物动态"
      }
    },
    {
      path: "/cadCraft",
      component: cadCraft,
      name: "cadCraft",
      meta: {
        title: "高速PCB设计 |  造物云"
      }
    },
    {
      path: "/industryCase",
      component: industryCase,
      name: "industryCase",
      meta: {
        title: "行业案例 | 造物云"
      }
    },
    {
      // 智能硬件
      path: "/smartHardware",
      component: industryCase,
      name: "smartHardware",
      meta: {
        title: "新能源解决方案 | 造物云",
        query: { type: 1 }
      }
    },
    {
      // 新能源
      path: "/newEnergy",
      component: industryCase,
      name: "newEnergy",
      meta: {
        title: "新能源解决方案 | 造物云",
        query: { type: 2 }
      }
    },
    {
      // 物联网
      path: "/InternetOfThings",
      component: industryCase,
      name: "InternetOfThings",
      meta: {
        title: "物联网解决方案 | 造物云",
        query: { type: 3 }
      }
    },
    {
      // 汽车
      path: "/automobile",
      component: industryCase,
      name: "automobile",
      meta: {
        title: "汽车解决方案 | 造物云",
        query: { type: 4 }
      }
    },
    {
      // 农牧
      path: "/Farming",
      component: industryCase,
      name: "Farming",
      meta: {
        title: "农牧解决方案 | 造物云",
        query: { type: 5 }
      }
    },
    {
      // 电力
      path: "/electricPower",
      component: industryCase,
      name: "electricPower",
      meta: {
        title: "电力解决方案  | 造物云",
        query: { type: 6 }
      }
    },
    {
      // 医疗
      path: "/medicalTreatment",
      component: industryCase,
      name: "medicalTreatment",
      meta: {
        title: "医疗解决方案 | 造物云",
        query: { type: 7 }
      }
    },
    {
      // 工控
      path: "/industrialControl",
      component: industryCase,
      name: "industrialControl",
      meta: {
        title: "工控解决方案 | 造物云",
        query: { type: 8 }
      }
    },
    {
      // 通讯
      path: "/communication",
      component: industryCase,
      name: "communication",
      meta: {
        title: "通讯解决方案 | 造物云",
        query: { type: 9 }
      }
    }
  ]
});

Router.beforeEach((to, from, next) => {
  // 功能页面 更改title
  console.log(to);
  if (to.path == "/pcbCraftSecondary") {
    if (to.query.type == 1) {
      to.meta.title = "HDI PCB |  造物云";
    } else if (to.query.type == 2) {
      to.meta.title = "高多层板 |  造物云";
    } else if (to.query.type == 3) {
      to.meta.title = "刚挠结合板|  造物云";
    } else if (to.query.type == 4) {
      to.meta.title = "高频板 |  造物云";
    } else if (to.query.type == 5) {
      to.meta.title = "厚铜电源板 |  造物云";
    } else if (to.query.type == 6) {
      to.meta.title = "金属基板 |  造物云";
    }
  } else if (to.path == "/pcbACraftSecondary") {
    if (to.query.type == 1) {
      to.meta.title = "电梯安全检测PCBA |  造物云";
    } else if (to.query.type == 2) {
      to.meta.title = "水位检测PCBA |  造物云";
    } else if (to.query.type == 3) {
      to.meta.title = "物联网模块PCBA |  造物云";
    } else if (to.query.type == 4) {
      to.meta.title = "晶闸管控制单元PCBA |  造物云";
    } else if (to.query.type == 5) {
      to.meta.title = "发射板PCBA|  造物云";
    } else if (to.query.type == 6) {
      to.meta.title = "主控板PCBA |  造物云";
    }
  }

  // console.log(Router.app.$options.store.state.userGuid);
  //  console.log(to.matched);
  //  console.log(Router.app.$options.store.state);
  // let isLogin = Router.app.$options.store.state.authorToken;
  // if (to.matched.some((record) => record.meta.requireLogin)) {
  //   if (!isLogin) {
  //     common.toLogin();
  //     next(false);
  //   }
  // }

  // if (/\b(login|register)\b/.test(to.path)) {
  //   Router.app.$options.store.dispatch('recordBeforeLoginPage', from.path);
  // }
  window.document.title = to.meta.title || "造物云创新 数字芯制造丨造物云";
  if (Router.app.$options.store.state.firstEnter) {
    if (!/root/.test(to.name)) {
      to.meta.isFirst = 1;
    }
    Router.app.$options.store.dispatch("recordHistory", {
      isFist: false,
      path: to
    });
  }
  next();
});

export default Router;



// WEBPACK FOOTER //
// ./src/router/index.js